class MFREggpunGenerator {
  constructor(index, element) {
    this.$index = index
    this.$element = $(element)

    this.selectors = {
      grid: '.cards__grid',
      item: '.cards__grid-item',
      trigger: '.cards-trigger',
      itemSelected: '.is-selected'
    }

    this.states = {
      isFlip: false
    }

    this.init()
  }

  init() {
    this.$element.find(this.selectors.item).on('click', this.selectCard.bind(this))
    this.$element.find(this.selectors.trigger).on('click', this.animateDeck.bind(this))
  }

  selectCard(event) {
    const $currentCard = $(event.currentTarget)

    $currentCard.addClass('is-selected')
    $currentCard.siblings().removeClass('is-selected')
    this.$element.find(this.selectors.grid).addClass('is-shuffled')
    this.$element.find(this.selectors.trigger).prop('disabled', false)
    this.$element.find(this.selectors.trigger).children().text(this.$element.find(this.selectors.trigger).children().data('text-2'))
  }

  animateDeck() {
    if ( this.states.isFlip ) {
      this.$element.find(this.selectors.itemSelected).removeClass('flip-over').removeClass('is-selected')
      this.$element.find(this.selectors.grid).removeClass('is-shuffled')
      this.$element.find(this.selectors.trigger).children().text(this.$element.find(this.selectors.trigger).children().data('text'))
      this.$element.find(this.selectors.trigger).prop('disabled', true)
      this.states.isFlip = false
    } else {
      this.$element.find(this.selectors.itemSelected).addClass('flip-over')
      this.$element.find(this.selectors.trigger).children().text(this.$element.find(this.selectors.trigger).children().data('text-3'))
      this.states.isFlip = true
    }
  }
}